/**
 * Created by adam on 8/9/17.
 */
(function (angular) {
  'use strict';

  if (!angular) return;
  angular
    .module('socialFabButton', ['ngMaterial'])
    .controller('socialFab',function autoComplete() {

      function isAndroid() {
        var body = document.querySelector("body");
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;  //&& ua.indexOf("mobile");
      }

      var self = this;
      self.isOpen=false;
      self.selectedDirection='up';
      self.selectedMode = 'md-fling';
      self.iconId = '#fab-ios-share';
      self.menuClose = 'fab-menu-close';

      if (isAndroid()){
        self.iconId  = '#fab-android-share';
      }

      self.menuIcon = self.iconId;

      self.changeIcon = function() {
        if (self.isOpen){
          self.menuIcon = self.iconId;
          self.menuClose = 'fab-menu-close';
        }
        else {
          self.menuClose="";
          self.menuIcon = '#fab-x-share';
        }
      };
      window.addEventListener('scroll', function () {
        if (self.menuIcon==='#fab-x-share'){
          self.menuIcon = self.iconId;
          self.menuClose = 'fab-menu-close';
        }
      });
    });
})(window['angular']);